import styled from "@emotion/styled";
import { Card } from "@mui/material";

export const ChatBotModal = styled(Card)`
  position: fixed;
  max-height: 600px;
  right: 10px;
  z-index: 999;
  bottom: 10px;
  width: 100%;
  height: 100%;
  max-width: 400px;
  transition: all 0.7s ease-in;
`;

export const GiftCityICon = styled("div")`
  position: fixed;
  z-index: 100;
  right: 10px;
  cursor: pointer;
  bottom: 10px;
  background: black;
  border-radius: 50%;
  height: 65px;
  width: 65px;
  padding: 7px;
`;
